module.exports = __webpack_public_path__ + "static/media/hvalue_new.1a68f289.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hvalue_new.jpg
// module id = 1929
// module chunks = 0